(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-accessory-compat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.dcsReady) return;
    window.dcsReady = true;

    var mq = window.matchMedia('(max-width: 749px)');

    function setOpen(item, open) {
      var btn = item.querySelector('.dcs__btn');
      item.classList.toggle('is-open', open);
      btn.classList.toggle('is-active', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openOnly(item) {
      var items = item.closest('.dcs').querySelectorAll('.dcs__item');
      for (var i = 0; i < items.length; i++) setOpen(items[i], items[i] === item);
    }

    function keepInView(item) {
      requestAnimationFrame(function () {
        var btn = item.querySelector('.dcs__btn');
        var panel = item.querySelector('.dcs__panel');
        var b = btn.getBoundingClientRect();
        var p = panel.getBoundingClientRect();
        if (b.top < 70 || p.bottom > window.innerHeight) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    function init(root) {
      root.setAttribute('data-ready', '');
      var first = root.querySelector('.dcs__item');
      if (first && !mq.matches) openOnly(first);
    }

    function initAll() {
      var roots = document.querySelectorAll('.dcs:not([data-ready])');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dcs__btn');
      if (!btn) return;
      var item = btn.closest('.dcs__item');
      if (mq.matches && item.classList.contains('is-open')) {
        setOpen(item, false);
        return;
      }
      openOnly(item);
      if (mq.matches) keepInView(item);
    });

    document.addEventListener('keydown', function (e) {
      var btn = e.target.closest('.dcs__btn');
      if (!btn) return;
      var all = Array.prototype.slice.call(btn.closest('.dcs').querySelectorAll('.dcs__btn'));
      var i = all.indexOf(btn);
      var next = null;
      if (e.key === 'ArrowDown') next = all[(i + 1) % all.length];
      else if (e.key === 'ArrowUp') next = all[(i - 1 + all.length) % all.length];
      else if (e.key === 'Home') next = all[0];
      else if (e.key === 'End') next = all[all.length - 1];
      if (next) { e.preventDefault(); next.focus(); }
    });

    // Going from mobile to desktop (rotation, resize): always keep one result open
    function onChange() {
      if (mq.matches) return;
      var roots = document.querySelectorAll('.dcs[data-ready]');
      for (var i = 0; i < roots.length; i++) {
        if (!roots[i].querySelector('.dcs__item.is-open')) {
          var first = roots[i].querySelector('.dcs__item');
          if (first) openOnly(first);
        }
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // Theme editor
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (e) {
      var item = document.getElementById('dcs-item-' + e.detail.sectionId + '-' + e.detail.blockId);
      if (item) openOnly(item);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-accessory-faq"] && !Shopify.designMode) return;
  try {
    
function tnAccessoryFaqInit(scope) {
 scope.querySelectorAll('.tn-faq').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const items = root.querySelectorAll('[data-faq-item]');
  function setState(item, open) {
   item.classList.toggle('is-open', open);
   item.querySelector('.tn-faq__trigger').setAttribute('aria-expanded', String(open));
   item.querySelector('.tn-faq__panel').inert = !open;
  }
  items.forEach(item => {
   setState(item, item.classList.contains('is-open'));
   item.querySelector('.tn-faq__trigger').addEventListener('click', () => {
    const open = !item.classList.contains('is-open');
    if (open && root.dataset.multiple !== 'true') items.forEach(other => { if (other !== item) setState(other, false); });
    setState(item, open);
   });
  });
 });
}
tnAccessoryFaqInit(document);
document.addEventListener('shopify:section:load', event => tnAccessoryFaqInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-accessory-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function update(c) {
      var cards = c.querySelector('.fbc__cards');
      var bar = c.querySelector('.fbc__bar');
      if (!cards) return;
      var max = cards.scrollWidth - cards.clientWidth;
      if (max > 4) { c.setAttribute('data-scrollable', ''); } else { c.removeAttribute('data-scrollable'); return; }
      if (!bar) return;
      var track = bar.parentNode.clientWidth;
      var w = Math.max(track * (cards.clientWidth / cards.scrollWidth), 28);
      var x = Math.min(Math.max(cards.scrollLeft / max, 0), 1) * (track - w);
      bar.style.width = w + 'px';
      bar.style.transform = 'translateX(' + x + 'px)';
    }
    function all() {
      var list = document.querySelectorAll('.fbc__carousel');
      for (var i = 0; i < list.length; i++) update(list[i]);
    }
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('fbc__cards')) update(t.parentNode);
    }, true);
    window.addEventListener('resize', all);
    window.addEventListener('load', all);
    document.addEventListener('shopify:section:load', all);
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  })();

  } catch(e) { console.error(e); }
})();
})();
